module.exports = __webpack_public_path__ + "static/icon_security-e65c31506c3c4d7ed55dd9ce6c84c368.jpg";